import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase/config";

export function observarAuth(callback) {
  return onAuthStateChanged(auth, callback);
}

export async function cadastrarUsuario(email, senha) {
  return createUserWithEmailAndPassword(auth, email, senha);
}

export async function entrarUsuario(email, senha) {
  return signInWithEmailAndPassword(auth, email, senha);
}

export async function sairUsuario() {
  return signOut(auth);
}